// Helpers for serving images through the ImageKit CDN. The backend owns the
// host (it returns ik.imagekit.io URLs); the FE only appends the ?tr= sizing
// params per render context.

const IMAGEKIT_HOST = "ik.imagekit.io";

// Parse a CSS size into a pixel number ("44px" / 44 -> 44). Returns null for
// non-pixel values like "100%" so callers can fall back to a default.
export const parsePx = (value) => {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const match = value.match(/^(\d+(?:\.\d+)?)px$/);
    if (match) return Math.round(parseFloat(match[1]));
  }
  return null;
};

// Append ImageKit width/height transforms. Only touches ImageKit-hosted URLs
// (non-ImageKit / external URLs are returned untouched) and never double-appends.
export const imageKitResize = (src, width, height) => {
  if (!src || typeof src !== "string") return src;
  if (!src.includes(IMAGEKIT_HOST)) return src;
  if (src.includes("tr=")) return src;
  const sep = src.includes("?") ? "&" : "?";
  return `${src}${sep}tr=w-${width},h-${height}`;
};
